import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const TableHeader = ({ title, actions, subtitle, isInCard = false }) => {
    return (
        <div className="flex py-6 px-4 md:flex-row flex-col items-center justify-between w-full gap-4">
            {!isInCard && (
                <div className="flex flex-col items-start justify-start gap-y-1">
                    <p className="text-base text-black90 font-medium">
                        {title}
                    </p>
                    {subtitle && subtitle !== '' && (
                        <p className="text-sm text-textDarkGray font-semibold">
                            {subtitle}
                        </p>
                    )}
                </div>
            )}
            {actions && (
                <div
                    className={clsx(
                        'flex flex-grow h-full items-center gap-x-4',
                        isInCard ? 'justify-between' : 'justify-end',
                    )}
                >
                    {actions?.map(action => action)}
                </div>
            )}
        </div>
    )
}

TableHeader.propTypes = {
    title: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.node),
    subtitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.any,
    ]),
    isInCard: PropTypes.bool,
}

export default TableHeader
